var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1V1.01124M5.5 1V1.01124M10 1V1.01124M19 1.02267V1.03392M1 18.9888V19M5.5 18.9888V19M10 18.9888V19M19 19.0114V19.0227M19 14.5142V14.5255M19 10.0171V10.0283M19 5.51986V5.53111M1 14.4916V14.5028M1 9.99438V10.0056M1 5.49719V5.50843M14.5 1.01124V1.02249M14.5 19V19.0112M5.5 5.49719H14.5V14.4916H5.5V5.49719Z",
    stroke: "#D6AF66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 8,
    height: 10,
    fill: "#D6AF66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenter);
export default __webpack_public_path__ + "static/media/center.4f97fade2c7b2c2bf6bfd76e4589028e.svg";
export { ForwardRef as ReactComponent };